import { Box, CircularProgress } from '@mui/material';
import { useCopy } from '@/hooks/useCopy';

export interface LoadingSpinnerProps {
  label?: string;
}

export function LoadingSpinner({ label }: LoadingSpinnerProps = {}) {
  const { t } = useCopy();
  const resolved = label ?? t('common.loading', 'Loading');
  return (
    <Box
      aria-busy="true"
      sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 96 }}
    >
      <CircularProgress aria-label={resolved} />
    </Box>
  );
}
